import React, { useState, useCallback } from 'react'
import sparkMD5 from 'spark-md5'
import { graphql, useStaticQuery } from 'gatsby';

function _scrollToID(id, speed){
	var targetOffset = window.$(id).offset().top;
  console.log(id, window.$(id), targetOffset)
	window.$('html, body').animate({scrollTop: targetOffset}, speed);
}

export function scrollToIdAction(sectionID, speed = 750) {
  return (event) => {
    event.preventDefault();
    _scrollToID('#' + sectionID, speed);
  }
}

export function scrollToTopAction() {
  return (event) => {
    event.preventDefault();
    window.$('html, body').animate({scrollTop:0}, 'slow'); 		  
  }
}

export function getAlternativesForPage(pageContext) {
  const pagePath = pageContext.intl.originalPath
  const siteUrl = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          siteUrl
        }
      }
    }
  `).site.siteMetadata.siteUrl
  return [
    ...pageContext.intl.languages.map(lang => (
      <link
        key={lang}
        rel="alternate"
        hrefLang={lang}
        href={`${siteUrl}/${lang}${pagePath}`}
      />
    )),
    <link
      key="x-default"
      rel="alternate"
      hrefLang="x-default"
      href={`${siteUrl}/${pageContext.intl.defaultLanguage}${pagePath}`}
    />
  ]
}


export function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return(item ? JSON.parse(item) : initialValue)
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return(initialValue);
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = useCallback(
    (value) => {
      try {
        // Save state
        setStoredValue(oldValue => {
          // Allow value to be a function so we have same API as useState
          const valueToStore = value instanceof Function ? value(oldValue) : value;

          // Save to local storage
          window.localStorage.setItem(key, JSON.stringify(valueToStore));

          // set the new state
          return valueToStore;
        });
      } catch (error) {
        // A more advanced implementation would handle the error case
        console.log(error);
      }
    },
    [key],
  );

  return [storedValue, setValue];
}



function readChunked(file, chunkCallback, endCallback) {
  const fileSize   = file.size;
  const chunkSize  = 4 * 1024 * 1024; // 4MB
  const chunks = Math.ceil(fileSize / chunkSize);
  const reader = new FileReader();
  let currentChunk = 0;

  reader.onload = function() {
    console.log('read chunk nr', currentChunk + 1, 'of', chunks);

    // if error
    if (reader.error) {
      endCallback(reader.error || {});
      return;
    }
    
    // if success
    currentChunk++;
    chunkCallback(reader.result, currentChunk / chunks); 
    if (currentChunk < chunks) {
      loadNext();
    } else {
      console.log('finished loading');
      endCallback(null);
    }
  };
  reader.onerror = function(err) {
    endCallback(err || {});
  };
  function loadNext() {
    const start = currentChunk * chunkSize;
    const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
    reader.readAsArrayBuffer(file.slice(start, end));
  }
  loadNext();
}

export function getMD5(blob, cbProgress) {
  return new Promise((resolve, reject) => {
    const spark = new sparkMD5.ArrayBuffer();

    readChunked(blob, (chunk, progressPercentage) => {
      spark.append(chunk);
      console.log("meh")
      if (cbProgress) {
        cbProgress(progressPercentage);
      }
    }, err => {
      if (err) {
        reject(err);
      } else {
        // TODO: Handle errors
        var sparkHash = spark.end()
        resolve(sparkHash);
      }
    });
  });
}